export default "__VITE_ASSET__BG8cdSNb__"